import React from 'react';

import Accordion from 'components/Accordion';
import Checkbox from 'components/DesignSystem/Checkbox';
import TitleSemiBold from 'components/Typography/TitleSemiBold';

interface FatorRenProps {
  valor: boolean;
  onChange: (valor: boolean) => void;
}

/**
 * Acordeon "Fator da REN" (padronizacao REN 2026-05-28).
 *
 * Checkbox unico "Incluir Fator da REN", default DESABILITADO (opt-in). Quando
 * marcado, o request envia `incluir_fator_ren=true` e o backend anexa a serie
 * REN (linha tracejada cinza) ao grafico, para a subdivisao espacial atual
 * (subsistemas / regioes EPE / conjuntos / usinas) — le as tabelas
 * tab_windx_agregacao_*_ren_{sh,sm} (e fat_windx_ren_usina para usinas).
 *
 * Presente em WEOL-SH (Semi-horario/Diario) e WEOL-SM (Semanal). Ausente na
 * sub-aba Comparativo — controlado no ControlPanel via `exibeFatorRen`.
 */
export default function FatorRen({ valor, onChange }: FatorRenProps) {
  return (
    <Accordion.Item eventKey="fator-ren">
      <Accordion.Header>
        <TitleSemiBold>Fator da REN</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        <Checkbox
          id="windx-fator-ren"
          label="Incluir Fator da REN"
          checked={valor}
          onChange={() => onChange(!valor)}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
